import type { ChangelogEntry } from "../types";

/** Lokasjoner på prosjekter med status (VIB-2940). */
export const LOKASJONER_PA_PROSJEKTER_2026_10: ChangelogEntry = {
  id: "2026-10-25-lokasjoner-pa-prosjekter",
  date: "2026-10-25",
  title: "Lokasjoner på prosjektene",
  summary: "Lokasjoner kan legges på prosjekter med status, prosjektet har fått en egen fane for dem, og historikken fra verktøyet kan kobles til riktig prosjekt.",
  sections: [
    {
      heading: "Lokasjoner",
      minRole: "user",
      items: [
        {
          title: "Legg på prosjekt",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Fra lokasjonskortet, eller flere på en gang ved å krysse av i tabellen. Lokasjonene legges på som Forslag.",
        },
        {
          title: "Fanen Lokasjoner på prosjektet",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Tabell og kart med status Forslag, Befart, Valgt, Brukt eller Forkastet. Når prosjektet avsluttes, blir Valgt til Brukt og statusene låses. Endringene står i Logg-fanen.",
        },
        {
          title: "Prosjektene på lokasjonskortet",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Lokasjonskortet viser prosjektene lokasjonen er vurdert eller brukt på. Historikken fra verktøyet kan kobles til riktig prosjekt linje for linje.",
        },
        {
          title: "Filteret «Brukt på prosjekt»",
          kind: "nytt",
          featureFlag: "feature_locations",
          body: "Viser bare lokasjoner som har vært brukt i en produksjon.",
        },
      ],
    },
  ],
};
